module.exports = __webpack_public_path__ + "img/qz-windows-tray.a21d700a.png";